/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateToggleRequest } from '../models/CreateToggleRequest';
import type { PagedFeatureToggles } from '../models/PagedFeatureToggles';
import type { PagedPaths } from '../models/PagedPaths';
import type { Toggle } from '../models/Toggle';
import { request as __request } from '../core/request';

export class TogglesService {

    /**
     * Search for toggles
     * @returns PagedFeatureToggles Success
     * @throws ApiError
     */
    public static async getToggles({
query,
page = '0',
pageSize = '30',
}: {
/** Search term **/
query?: string,
/** Page number **/
page?: string,
/** Page size **/
pageSize?: string,
}): Promise<PagedFeatureToggles> {
        const result = await __request({
            method: 'GET',
            path: `/toggles/`,
            query: {
                'query': query,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                403: `Access Denied`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Create (or restore) a new Toggle
     * @returns Toggle Success
     * @throws ApiError
     */
    public static async postToggles({
requestBody,
}: {
requestBody: CreateToggleRequest,
}): Promise<Toggle> {
        const result = await __request({
            method: 'POST',
            path: `/toggles/`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Access Denied`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Search for paths
     * @returns PagedPaths Success
     * @throws ApiError
     */
    public static async getTogglePaths({
query,
page = '0',
pageSize = '30',
}: {
/** Search term **/
query?: string,
/** Page number **/
page?: string,
/** Page size **/
pageSize?: string,
}): Promise<PagedPaths> {
        const result = await __request({
            method: 'GET',
            path: `/toggles/paths`,
            query: {
                'query': query,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                403: `Access Denied`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Get exact Feature Toggle state for specified audience
     * @returns Toggle Success
     * @throws ApiError
     */
    public static async getToggleForFeatureAndAudience({
featureToken,
audienceTokens,
}: {
featureToken: string,
audienceTokens: string,
}): Promise<Toggle> {
        const result = await __request({
            method: 'GET',
            path: `/toggles/${featureToken}/audience/${audienceTokens}`,
            errors: {
                403: `Access Denied`,
                404: `Not found`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Get exact Feature Toggle state for specified path
     * @returns Toggle Success
     * @throws ApiError
     */
    public static async getToggleForFeatureAndPath({
featureToken,
pathTokens,
}: {
featureToken: string,
pathTokens: string,
}): Promise<Toggle> {
        const result = await __request({
            method: 'GET',
            path: `/toggles/${featureToken}/path/${pathTokens}`,
            errors: {
                403: `Access Denied`,
                404: `Not found`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

    /**
     * Delete existing Toggle
     * @returns void 
     * @throws ApiError
     */
    public static async deleteToggleById({
id,
}: {
id: number,
}): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/toggles/${id}`,
            errors: {
                400: `Bad Request`,
                403: `Access Denied`,
                500: `Internal Server error`,
            },
        });
        return result.body;
    }

}